import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  calendarNav: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    margin: '10px 20px',
  },
  date: {
    fontFamily: 'Roboto',
    fontSize: '18px',
    color: '#000000',
    fontWeight: 700,
    marginLeft: '20px',
    minWidth: '140px'
  },
  arrows: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    minWidth: '60px',
    alignItems: 'center',
    color: 'rgba(44, 45, 62, 0.8)',
    margin: '5px',
    cursor: 'pointer'
  }
}));
